import React from "react";
import { FormProvider, useForm } from "react-hook-form";
import { Box } from "@mui/material";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import {
  ContainerSection,
  MAutocomplete,
  MButton,
  MDatePicker,
  ResponsiveFormContainer,
} from "@app/components";
import { useTransitDose } from "../utils/useTransitDose";
import { useInstallation } from "@services/servicesGenericsTables";
import { IFormFilterTransitDose } from "@app/types/transitDose.types";

const FilterTransitDose = () => {
  const { setQuery } = useTransitDose();
  const form = useForm<IFormFilterTransitDose>({ mode: "all" });
  const { installationList } = useInstallation();

  const submit = (data: IFormFilterTransitDose) => {
    setQuery(data);
  };

  const clearFilters = () => {
    form.reset();
    setQuery({});
  };

  return (
    <ContainerSection label="Filtros">
      <FormProvider {...form}>
        <form onSubmit={form.handleSubmit(submit)}>
          <Box sx={{ display: "flex", justifyContent: "center" }}>
            <ResponsiveFormContainer columns={5}>
              <MAutocomplete
                key={JSON.stringify(form.watch("instalation"))}
                name="instalation"
                options={installationList}
                label="Instalación"
                getOptionLabel={(option) =>
                  `${option.codigo} - ${option.descripcion}`
                }
              />
              <MDatePicker
                name="registration_date_from"
                pickerType="date"
                label="Fecha registro desde"
              />
              <MDatePicker
                name="registration_date_to"
                pickerType="date"
                label="Fecha registro hasta"
              />
            </ResponsiveFormContainer>
            <Box sx={{ display: "flex", alignItems: "center", ml: 2 }}>
              <MButton
                variant="outlined"
                color="primary"
                sx={{ textTransform: "uppercase" }}
                text="Filtrar"
                type="submit"
                startIcon={<FilterAltIcon />}
              />
              <MButton
                variant="outlined"
                color="secondary"
                sx={{ textTransform: "uppercase", ml: 2 }}
                text="Limpiar"
                onClick={clearFilters}
              />
            </Box>
          </Box>
        </form>
      </FormProvider>
    </ContainerSection>
  );
};

export default FilterTransitDose;
